import { useContext, useState, useMemo } from "react";
// import { format } from "date-fns";
import CartItem from "./CartItem";
import { CurrencyContext } from "contexts/currency";
import { useCart } from "lib/hooks/useCart";

export default function ExperienceCartItem({ item }) {
  const [options, setOptions] = useState({
    startDate: item?.startDate !== "None" ? item?.startDate : "None",
    people: item?.people ?? 1,
    duration:
      item?.duration &&
      item?.duration > item?.experience?.attributes?.metadata?.minimum_duration
        ? item?.duration
        : item?.experience?.attributes?.metadata?.minimum_duration ?? 1,
  });

  const { updateItem } = useCart();

  function updateOptions({ option, value }) {
    setOptions((prev) => {
      return {
        ...prev,
        [option]: value,
      };
    });
  }

  async function handleOptionsChange({ option, value }) {
    await updateItem({
      cartId: item.cartId,
      type: "experience",
      updateObject: { ...options, [option]: value },
    });

    if (options[option] !== value) {
      updateOptions({ option, value });
    }
  }

  // const handleOptionsChange = useMemo(
  //   () =>
  //     async ({ option, value }) => {
  //       console.log(option, value);
  //       await updateItem({
  //         cartId: item.cartId,
  //         type: "experience",
  //         updateObject: { ...options, [option]: value },
  //       });

  //       console.log(options);

  //       await updateOptions({ option, value });
  //     },
  //   [item.cartId, updateItem]
  // );

  const { currency } = useContext(CurrencyContext);

  const { experience } = item;

  if (!experience?.attributes) {
    return null;
  }

  const { experience_title, slug, seo, location, metadata } =
    experience.attributes;
  // Metadata
  const { currencies, minimum_duration } = metadata;

  // Image
  const imageUrl = seo?.metaMedia?.data?.attributes?.url;

  // Location
  const country = location[0]?.country?.data?.attributes?.countryName;
  const city = location[0]?.cities?.data?.[0]?.attributes?.name;
  const subtitleText = `${city}, ${country}`;

  const unitPrice = parseFloat(currencies[currency.code]);
  // Price
  let currentPrice = `${currency.symbol}${
    unitPrice * options.people * options.duration
  } `;

  // Cart item inputs row
  const inputs = [
    {
      name: "start",
      id: "startDate",
      label: "Start Date",
      type: "date",
      initialValue: options?.startDate ?? "None",
    },
    {
      name: "duration",
      label: "Weeks",
      id: "duration",
      type: "number",
      min: minimum_duration ?? 1,
      initialValue: options?.duration,
    },
    {
      name: "people",
      label: "People",
      id: "people",
      type: "number",
      min: 1,
      initialValue: options?.people,
    },
    {
      name: "weekly-price",
      label: "Per week",
      id: "weekly-price",
      type: "static",
      initialValue: unitPrice,
      mode: "static",
    },
  ];

  return (
    <CartItem
      cartId={item?.cartId}
      title={experience_title}
      slug={`experience/${slug}`}
      image={imageUrl}
      type="experience"
      subtitleText={subtitleText}
      currencies={currencies}
      currency={currency}
      price={currentPrice}
      unitPrice={unitPrice}
      inputs={inputs}
      options={options}
      handleOptionsChange={handleOptionsChange}
    />
  );
}
